import { APPROVED, EDITED, REJECTED } from "../../utils/status";


const BmpStatus = ({status}) => {
    let statusText = 'Pending Review';
    if (status === APPROVED) {
        statusText = 'Live';
    } 
    if (status === REJECTED) {
        statusText = 'Rejected';
    }
    if (status === EDITED) {
        statusText = 'Pending Review Edited';
    }
    // if (status === PENDING) {
    //     return 'Pending Review';
    // }  
    return statusText;
}

export default BmpStatus;